import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { TimezoneProvider } from "@/contexts/TimezoneContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Departments from "@/pages/Departments";
import Schedule from "@/pages/Schedule";
import Careers from "@/pages/Careers";
import HRInvestigations from "@/pages/HRInvestigations";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Hosts from "@/pages/Hosts";
import HostDetail from "@/pages/HostDetail";
import ShowsIndex from "@/pages/ShowsIndex";
import ShowDetail from "@/pages/ShowDetail";
import Watchlist from "@/pages/Watchlist";
import HostStudio from "@/pages/HostStudio";
import Team from "@/pages/Team";
import Banned from "@/pages/Banned";
import Profile from "@/pages/Profile";
import Leaderboard from "@/pages/Leaderboard";
import Verify from "@/pages/Verify";
import VerifyDiscord from "@/pages/VerifyDiscord";
import Memberships from "@/pages/Memberships";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PaymentPayPalReturn from "@/pages/PaymentPayPalReturn";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import SsoCallback from "@/pages/SsoCallback";
import DefconPage from "@/pages/DefconPage";
import MaintenanceGate from "@/components/MaintenanceGate";
import DonatePage from "@/pages/DonatePage";
import DonationThanks from "@/pages/DonationThanks";
import MerchThanks from "@/pages/MerchThanks";
import Overlay from "@/pages/Overlay";
import Policies from "@/pages/Policies";
import BlacklistRecheck from "@/pages/BlacklistRecheck";
import Contracts from "@/pages/Contracts";
import ContractView from "@/pages/ContractView";

export default function App() {
  return (
    <AuthProvider>
      <TimezoneProvider>
      <BrowserRouter>
        <Routes>
          {/* Bare OBS overlay — no navbar/footer/maintenance chrome */}
          <Route path="/overlay/:token" element={<Overlay />} />
          <Route path="*" element={
            <MaintenanceGate>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/departments" element={<Departments />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/shows" element={<ShowsIndex />} />
                <Route path="/shows/:id" element={<ShowDetail />} />
                <Route path="/defcon" element={<DefconPage />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/hr-investigations" element={<HRInvestigations />} />
                <Route path="/hosts" element={<Hosts />} />
                <Route path="/hosts/:name" element={<HostDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/sso/callback" element={<SsoCallback />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/watchlist" element={<Watchlist />} />
                <Route path="/host-studio" element={<HostStudio />} />
                <Route path="/team" element={<Team />} />
                <Route path="/banned" element={<Banned />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/verify" element={<Verify />} />
                <Route path="/verify-discord" element={<VerifyDiscord />} />
                <Route path="/memberships" element={<Memberships />} />
                <Route path="/donate/:hostId" element={<DonatePage />} />
                <Route path="/donation/thanks" element={<DonationThanks />} />
                <Route path="/merch/thanks" element={<MerchThanks />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/payment/paypal/return" element={<PaymentPayPalReturn />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="/blacklist-recheck" element={<BlacklistRecheck />} />
                <Route path="/contracts" element={<Contracts />} />
                <Route path="/contracts/:id" element={<ContractView />} />
              </Routes>
            </Layout>
            </MaintenanceGate>
          } />
        </Routes>
        <Toaster theme="dark" position="top-right" />
      </BrowserRouter>
      </TimezoneProvider>
    </AuthProvider>
  );
}
